export default "__VITE_ASSET__3o4wMr9x__"